/**
 * Who may look up owner identity from Leads (#585 AC1/AC2).
 *
 * Its own module rather than living beside the button, because a file that
 * exports both a component and a hook breaks React Fast Refresh — and the
 * repo's lint warning ceiling is ratcheted, so it may not grow.
 *
 * `oppslag_premium_user` is a pure API entitlement: it does not open the
 * Oppslag page, and a Leads user does not need `oppslag_basic_user` to use
 * this. Grids call this for the header cell as well as the body cell, so a
 * user without the role gets no empty column.
 */
import { useAuth } from '../../../contexts/AuthContext'
import { hasAnyRole, ROLE_OPPSLAG_PREMIUM } from '../../../utils/roles'

export function useKanSeEierhistorikk(): boolean {
  const { user } = useAuth()
  return hasAnyRole(user, [ROLE_OPPSLAG_PREMIUM])
}
